import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { clientFilter } from '../../models/client.model'
import { Subscription } from 'rxjs'
import { FormControl, FormGroup, Validators } from '@angular/forms'

@Component({
	selector: 'app-client-filter',
	templateUrl: './client-filter.component.html',
	styleUrls: ['./client-filter.component.scss'],
})
export class ClientFilterComponent implements OnInit {
	@Output() emitFilter = new EventEmitter()
	@Output() emitFilterCount = new EventEmitter()
	@Input() filterData: clientFilter = {
		paging: { pageNumber: 1, pageSize: 10 },
		searchText: '',
		countryId: [],
		selectedCountries: [],
		minDate: '',
		maxDate: '',
		hasAppointments: false,
		minAppointmentCount: null,
		maxAppointmentCount: null,
	}
	subscription = new Subscription()
	filterForm: FormGroup = new FormGroup({})
	filterCount = 0
	constructor() {}

	ngOnInit(): void {
		this.initForm()
		this.valechange()
		this.filterForm.valueChanges.subscribe((val) => {
			this.filterCount = 0

			for (let value in val) {
				if (
					(this.getController(value).value ||
						this.getController(value).value == 0) &&
					this.getController(value).value != false
				)
					this.filterCount += 1
			}
		})
	}

	initForm() {
		this.filterForm = new FormGroup({
			searchText: new FormControl(this.filterData?.searchText || null),
			countryId: new FormControl(this.filterData?.countryId || null),
			selectedCountries: new FormControl(this.filterData.selectedCountries),
			minDate: new FormControl(this.filterData?.minDate || null),
			maxDate: new FormControl(this.filterData?.maxDate || null),
			hasAppointments: new FormControl(
				this.filterData?.hasAppointments || null
			),
			minAppointmentCount: new FormControl(
				this.filterData?.minAppointmentCount || null,
				[
					Validators.min(1),
					Validators.max(+this.filterForm?.get('maxAppointmentCount')?.value),
				]
			),
			maxAppointmentCount: new FormControl(
				this.filterData?.maxAppointmentCount || null,
				[Validators.min(+this.filterForm?.get('minAppointmentCount')?.value)]
			),
		})
	}
	getController(controlName: string) {
		return (this.filterForm as FormGroup).controls[controlName] as FormControl
	}

	resetFilter() {
		this.filterForm.reset()
		this.filterData = {
			...this.filterData,
			...this.filterForm.getRawValue(),
		}
		this.getController('selectedCountries').setValue([])
		this.emitFilter.emit(this.filterData)
		this.emitFilterCount.emit(this.filterCount)
	}
	submit() {
		this.filterData = {
			...this.filterData,
			...this.filterForm.getRawValue(),
			minDate: this.getController('minDate')?.value
				? new Date(this.getController('minDate')?.value).toISOString()
				: null,
			endDate: this.getController('maxDate')?.value
				? new Date(this.getController('maxDate')?.value).toISOString()
				: null,
		}

		this.emitFilter.emit(this.filterData)
		this.emitFilterCount.emit(this.filterCount)
	}
	countryChange(event: any, controller: string) {
		if (event?.checked) {
			!this.getController(controller).value
				? this.getController(controller).setValue([])
				: null
			this.getController(controller).setValue([
				...this.getController(controller).value,
				event.source.value,
			])
		} else {
			let objIndex = [...this.getController(controller).value]?.indexOf(
				event.source.value
			)
			let newArray = this.getController(controller).value
			newArray.splice(objIndex, 1)
			this.getController(controller).setValue(newArray)
		}
	}

	valechange() {
		this.filterForm.valueChanges.subscribe((res: any) => {
			if (!this.getController('maxAppointmentCount').value !== null) {
				this.filterForm.controls.minAppointmentCount.clearValidators()
			}
		})
	}

	ngOnDestroy() {
		this.subscription.unsubscribe()
	}
}
